import React from 'react';
import { authenticationService } from '../../services/authenticationService.js';
import * as styles from "./login.module.scss"

export default class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        if (authenticationService.currentUserValue) {
            this.props.history.push('/');
        }

        this.state = {
            userData: { userName: '', password: '' },
            loginError: '',
            isSubmitting: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.userNameChanged = this.userNameChanged.bind(this);
        this.userPasswordChanged = this.userPasswordChanged.bind(this);
        this.setError = this.setError.bind(this);
    }

    setSubmitting(value) {
        let data = this.state;
        data.userData.isSubmitting = value;
        this.setState(data);
    }

    userNameChanged(e) {
        let data = this.state;
        data.userData.userName = e.target.value;
        this.setState(data);
    }

    userPasswordChanged(e) {
        let data = this.state;
        data.userData.password = e.target.value;
        this.setState(data);
    }

    setError(error) {
        let data = this.state;
        data.loginError = error;
        this.setState(data);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setSubmitting(true);
        authenticationService.login(this.state.userData.userName, this.state.userData.password).then(
            user => {
                const { from } = this.props.location.state || { from: { pathname: "/" } };
                this.setSubmitting(false);
                this.props.history.push(from);
            },
            error => {
                this.setError(error);
                this.setSubmitting(false);
            }
        );
    }

    render() {
        return (
            <div className={styles.login_form_container}>
                <form onSubmit={this.handleSubmit}>
                    <p>
                        <label>User Name:</label><br />
                        <input type="text" onChange={this.userNameChanged} />
                    </p>
                    <p>
                        <label>Password:</label><br />
                        <input type="password" onChange={this.userPasswordChanged} />
                    </p>
                    <button type="submit">Log in</button>
                </form>
            </div>
            )
    }
}
